<template>
  <main class="password-recovery">
    <h1>ตั้งรหัสผ่านใหม่</h1>
    <p>สำหรับเข้าใช้งานแอพและเว็บไซต์ WEL</p>
    <form v-if="token && !done" @submit.prevent="submit">
      <label for="new-password">รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)</label>
      <input id="new-password" v-model="password" type="password" autocomplete="new-password" required minlength="8" :disabled="busy">
      <label for="confirm-password">ยืนยันรหัสผ่านใหม่</label>
      <input id="confirm-password" v-model="confirmation" type="password" autocomplete="new-password" required minlength="8" :disabled="busy">
      <button type="submit" :disabled="busy">{{ busy ? 'กำลังบันทึก…' : 'ยืนยันรหัสผ่านใหม่' }}</button>
    </form>
    <p role="status" aria-live="polite">{{ message }}</p>
    <router-link to="/user/login">กลับไปหน้าเข้าสู่ระบบบนเว็บไซต์</router-link>
  </main>
</template>

<script>
import { graphQlUrl } from '@/constants/config'

export default {
  data() {
    return { token: '', password: '', confirmation: '', busy: false, done: false, message: '' }
  },
  created() {
    const match = /^#token=([a-zA-Z0-9_.-]+)$/.exec(this.$route.hash || '')
    this.token = match ? match[1] : ''
    // Opening a link does not consume it; remove the credential from browser history.
    if (this.token) window.history.replaceState(window.history.state, '', window.location.pathname)
    else this.message = 'ลิงก์ไม่ถูกต้องหรือเป็นลิงก์รูปแบบเดิม กรุณาขอลิงก์ตั้งรหัสผ่านใหม่จากหน้าเข้าสู่ระบบ'
  },
  methods: {
    async submit() {
      if (this.busy) return
      if (this.password !== this.confirmation) {
        this.message = 'รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน'
        return
      }
      this.busy = true
      this.message = ''
      try {
        // No cached Authorization or refresh token is sent.
        const response = await fetch(graphQlUrl, {
          method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: 'mutation CompleteStudentPasswordReset($token: String!, $newPassword: String!) { completeStudentPasswordReset(token: $token, newPassword: $newPassword) { result msg } }',
            variables: { token: this.token, newPassword: this.password }
          })
        })
        const payload = await response.json()
        const result = payload.data && payload.data.completeStudentPasswordReset
        if (!response.ok || payload.errors || !result) throw new Error('reset_failed')
        this.message = result.msg
        this.done = result.result === true
        if (this.done) {
          this.token = ''
          this.password = ''
          this.confirmation = ''
        }
      } catch (error) {
        this.message = 'ไม่สามารถดำเนินการได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่'
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.password-recovery { max-width: 460px; margin: 60px auto; padding: 24px; background: white; border-radius: 12px; color: #263238; }
h1 { font-size: 24px; margin-bottom: 16px; }
p { margin: 16px 0; }
label, input, button { display: block; width: 100%; }
label { margin-top: 16px; }
input { padding: 12px; border: 1px solid #999; border-radius: 6px; margin-top: 8px; }
button { margin-top: 24px; padding: 12px; color: white; background: #4059ad; border: 0; border-radius: 6px; cursor: pointer; }
button:disabled { opacity: .6; cursor: wait; }
</style>
